import {fetchWithState, getFetchedJSON} from '~/misc/fetch';

export const createOffer = (getState, shipmentId, amount) => fetchWithState(getState, {
  url: `/shipments/${shipmentId}/offers`,
  method: 'POST',
  body: {offer_amount: amount},
}).then(getFetchedJSON);

export default {
  createOffer,
};



// WEBPACK FOOTER //
// ./src/api/offers.js